import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please select a type of event' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select a date for your event' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    plannedguestcount: {
      validations: []
    },
    reference: {
        validations: []
      },
    notes: {
        validations: []
      },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name*',
            mapping: 'firstName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name*',
            mapping: 'lastName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email*',
            mapping: 'email'
          },
         ]
        },
        {
          fields: [
           {
             type: 'text',
             size: 'Medium',
             label: 'Phone*',
             mapping: 'telNumber'
           }
         ]
       },
      {
        fields: [
          {
            type: 'text',
            size: 'XLarge',
            label: 'Type of Event*',
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Date of Event*',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'XLarge',
            label: 'How did you find us?',
            options: [
              { label: 'Repeat Client' , value: 'Repeat Client'},
              { label: 'Client Referral', value: 'Client Referral' },
              { label: 'Website', value: 'Website' },
              { label: 'Planner (Event, Caterer)', value: 'Planner' },
              { label: 'Owner Referral', value: 'Owner Referral' },
              { label: 'Employee Referral', value: 'Employee Referral' },
              { label: 'Mailing', value: 'Mailing' },
              { label: 'Cold Contact', value: 'Cold Contact' }
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Additional Comments',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Hand Crafted Catering + Events Contact Us Form',
    formId: '564',
    clientKey: 'E436FD4A-B662-4A1B-AC5D-02548CA25E66',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/handcraftedcatering/form_structure.js